import {
  GarageRegisterAnnouncement,
  GarageRegisterAnnouncementCreateDto,
  GarageRegisterAnnouncementUpdateDto,
} from "@/lib/types/garage-register/announcements";
import { createQueryHooks } from "../base";
import { garageRegisterAnnouncementsService } from "@/lib/api/garage-register/announcements";

// Generate standard hooks
const standardHooks = createQueryHooks<
  GarageRegisterAnnouncement,
  GarageRegisterAnnouncementCreateDto,
  GarageRegisterAnnouncementUpdateDto
>("garageRegistersAnnouncements", garageRegisterAnnouncementsService);

// Export standard hooks
export const {
  keys: garageRegisterAnnouncementsKeys,
  useEntities: useGarageRegisterAnnouncements,
  useEntity: useGarageRegisterAnnouncement,
  useCreateEntity: useCreateGarageRegisterAnnouncement,
  useUpdateEntity: useUpdateGarageRegisterAnnouncement,
  useDeleteEntity: useDeleteGarageRegisterAnnouncement,
} = standardHooks;
